import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination } from 'src/app/shared/models';
import { GenericCRUDService } from 'src/app/shared/services';

@Injectable({
    providedIn: 'root'
})
export class LocaisApresentacaoService extends GenericCRUDService {

    constructor(http: HttpClient) {
        super(http);
        this.url = `/admin/local-apresentacao`;
    }

    override getPaginated<LocaisApresentacao>(page: number, pageSize: number, orgaoId?: string): Observable<Pagination<LocaisApresentacao>> {
        const params = new URLSearchParams();
        params.append('page', `${page}`);
        params.append('pageSize', `${pageSize}`);
        orgaoId && params.append('orgaoId', `${orgaoId}`);

        return this.http.get<Pagination<LocaisApresentacao>>(`${this.url}?${params}`);
    }
}
